var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"brand-item",on:{"click":function($event){return _vm.skipClassify(item)}}},[_c('img',{attrs:{"src":item.banner,"alt":""}}),_vm._v(" "),_c('van-cell',{attrs:{"title":item.name}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a24c1f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Instrument/Components/Brand.vue
// module id = null
// module chunks = 